import { SvgIconProps } from './icon-props';

export default function ArrowCollapse({
	fill = 'none',
	height = 5,
	role,
	width = 12,
	pathFill = '#030303',
	className,
}: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 12 5"
			fill={fill}
			xmlns="http://www.w3.org/2000/svg"
			role={role}
			className={className}
		>
			<path
				d="M1.96006 0L0.574219 0.00301734L6.08012 5L11.5742 0.00301734L10.2044 0.00301734L1.96006 0Z"
				fill={pathFill}
			/>
		</svg>
	);
}
